module.exports = __webpack_public_path__ + "284b81dab3894fdf496b18ce10b5867e.png";